<div class="permission-container">
    <div class="permission-row">
      <div class="permission-alert-triangle"></div>
      <div class="permission-title">{{ 'permissionDenied.title' | translate }}</div>
      <div class="permission-description">{{ 'permissionDenied.description' | translate }}</div>
      <ng-container *ngIf="purecloudUri$ | async as uri">
        <button class="btn btn-dark center permission-btn" id="navigateBack" (click)="navigate(uri)">{{ 'permissionDenied.navigateButtonTitle' | translate}}</button>
      </ng-container>
    </div>
</div>

